import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "./button";
import { UsersAPI } from "../APIs/users.api";
import { useToast } from "./toast";

export const PasswordRestore = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { addToast } = useToast();

  const handleRestorePassword = async () => {
    try {
      const response = await UsersAPI.resetPassword();
      if (response.statusCode === 200) {
        addToast({
          type: "success",
          message: "Se ha restablecido tu contraseña",
          location: "bottom-center",
        });
        navigate("/dashboard/new-credentials", {
          state: {
            username: response.data.username,
            password: response.data.password,
            ownCredentials: true,
          },
        });
      } else {
        addToast({
          type: "error",
          message: response.message,
          location: "bottom-center",
        });
      }
    } catch (error) {
      addToast({
        type: "error",
        message: "Error al reestablecer la contraseña",
        location: "bottom-center",
      });
    } finally {
      setShowModal(false);
    }
  };

  return (
    <div className="w-full p-8">
      <div>
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Seguridad de la Cuenta
          </h2>
          <p className="text-gray-600 mb-6">
            Podés restablecer tu contraseña si creés que tu cuenta fue
            comprometida o simplemente querés actualizarla por seguridad.
          </p>

          <Button
            onClick={() => setShowModal(true)}
            text="Restablecer Contraseña"
            variant="primary"
          />

          {showModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
                <h2 className="text-xl font-bold mb-4">Confirmación</h2>
                <p className="mb-4">
                  ¿Estás seguro de que deseas restablecer tu contraseña?
                </p>

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 text-gray-600 hover:text-gray-800"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleRestorePassword}
                    className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition-colors"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <Outlet />
      </div>
    </div>
  );
};
